// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Asset } from './asset';
import { Bankrupt } from './bankrupt';
import { Counterparty } from './counterparty';
import { User } from './user';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Contribution extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  contributionId!: number;
  assessmentDate!: Date;
  bankruptId!: number;
  capendDate!: Date;
  capstartDate!: Date;
  contributionLiability!: number;
  contributionPeriod?: number;
  contributionType!: number;
  counterpartyId?: number;
  courtName?: string;
  courtProceedingMatterNo?: string;
  courtProceedingYear?: string;
  createdBy!: string;
  createdDate!: Date;
  dependantsNumber?: number;
  followUpDate?: Date;
  followUpUserId?: number;
  grossIncome!: number;
  incomeThreshold!: number;
  instalmentAmount!: number;
  memo?: string;
  noticeDate?: Date;
  noticeUserId?: number;
  numberOfPayments?: number;
  otherDeductions!: number;
  paymentsEndDate?: Date;
  paymentsStartDate?: Date;
  status?: number;
  taxDeductions!: number;
  totalReceived!: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  assets!: Asset[];
  bankrupt!: Bankrupt;
  counterparty!: Counterparty;
  followUpUser!: User;
  noticeUser!: User;
}

